import {
  type TClientSecurityUpdateDto,
  type TSecurityApi,
  type TSecurityCreateDto,
  type TSecurityDetailedApi
} from '@/components/App/Security/types/security.types';
import { type TSecurityFilters } from '@/store/security.slice';

import { ApiConnector } from '../api.connector';

class SecurityApi extends ApiConnector {
  startBadgeSecurity(): Promise<number> {
    return this.call({
      path: 'security/count/newCount'
    });
  }

  createSecurityRequest(data: TSecurityCreateDto): Promise<string> {
    return this.call({ path: 'security/create', body: data, method: 'post' });
  }

  getSecurityRequests(filters: TSecurityFilters): Promise<
    [
      {
        total: number;
        data: TSecurityApi[];
      }
    ]
  > {
    return this.call({ path: 'security', body: filters, method: 'post' });
  }

  getSecurityRequest(requestId: string): Promise<TSecurityDetailedApi> {
    return this.call({ path: `security/${requestId}` });
  }

  updateStatusSecurityRequest(
    requestId: string,
    data: TClientSecurityUpdateDto
  ): Promise<void> {
    return this.call({
      path: `security/${requestId}`,
      body: data,
      method: 'patch'
    });
  }
}

export const securityApi = new SecurityApi();
